<template functional>
  <small
    v-if="
      $options.isValid(props.checkValid)
        ? !props.noValid
        : props.noInvalid
          ? false
          : true
    "
  >
    <span
      :class="[
        $options.isValid(props.checkValid) ? 'valid' : props.invalidColor,
        'px-2 mx-1 entsys--chip'
      ]"
      style="color: white"
    >
      {{ $options.isValid(props.checkValid) ? props.valid : props.invalid }}
    </span>
  </small>
</template>
<script>
export default {
  name: "AppValidationAlert",
  props: {
    checkValid: {
      type: [Boolean, String, Promise],
      default: null
    },
    invalid: {
      type: String,
      default: "Invalid"
    },
    valid: {
      type: String,
      default: "Valid"
    },
    noInvalid: {
      type: Boolean,
      default: false
    },
    noValid: {
      type: Boolean,
      default: false
    },

    invalidColor: {
      type: String,
      default: "red"
    }
  },
  isValid(valid) {
    return valid;
  }
};
</script>
